// import React from 'react';
import ReactDOM from 'react-dom';
// import ShareBarWidget from './share/share-bar-widget';
// import '../stylesheets/sharebar.scss';

function fixAndAddIconToPlaylistWatchThumb(component) {
  let textContainerEl = ReactDOM.findDOMNode(component).querySelector(".playkit-video-stage__video-watching-thumb-text");
  if (textContainerEl !== null) {
    textContainerEl.textContent = '';
    let playIconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    playIconSvg.setAttribute('class', 'svgPlayIcon');
    playIconSvg.setAttribute('viewBox', '0 0 24 24');

    let playIconUseRef = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    playIconUseRef.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#immersive-lightbox-play-icon-shape');

    playIconSvg.appendChild(playIconUseRef);
    textContainerEl.appendChild(playIconSvg);
    textContainerEl.insertAdjacentText('beforeEnd', 'Assistindo');
  }
}

function addEscCloseEventToDocument(closeCallback) {
  document.addEventListener("keydown", event => {
    if (event.keyCode === 27) {
      closeCallback();
    }
  });
}

function addShareBar(url, title) {
  if (!window.ShareBar) return
  const FACEBOOK_APP_ID = window.cdaaas.SETTINGS.FACEBOOK_APP_ID

  let rootElement = document.querySelector('.playkit-video-info__details')
  if (!rootElement) return

  let shareElement = document.querySelector('.immersive-share')
  if (shareElement) rootElement.removeChild(shareElement)

  shareElement = document.createElement('div')
  shareElement.classList.add('immersive-share', 'immersive-social')
  rootElement.appendChild(shareElement)

  shareElement.dataset.title = title
  shareElement.dataset.url = url

  window.immersiveShare = new window.ShareBar({
    selector: '.immersive-share',
    theme: 'minimal',
    networks: ['facebook', 'twitter', 'whatsapp'],
    context: 'mobile',
    campaign: 'immersive-lightbox',
    facebookAppId: FACEBOOK_APP_ID
  })
}

export { fixAndAddIconToPlaylistWatchThumb, addEscCloseEventToDocument, addShareBar };